const Categories = () => (
  <div className="container pt-3">
    <button className="btn btn-primary" type="submit">Check Status</button>
  </div>
);

export default Categories;
